import { cn } from "twyne-new.ui"

export default function ColumnResizer({ header, canResize, tableContext }) {
  const table = tableContext()

  if (!canResize) {
    return null
  }

  const isRtl = table.options.columnResizeDirection === 'rtl'
  const isResizing = header.column.getIsResizing()

  return <div
    onDoubleClick={() => header.column.resetSize()}
    onMouseDown={header.getResizeHandler()}
    onTouchStart={header.getResizeHandler()}
    className={cn(
      'absolute top-0 h-full w-[3px] cursor-col-resize select-none touch-none',
      isResizing ? 'twy-bg-accent opacity-100' : 'twy-subtle-neutral opacity-0 group-hover:opacity-100',
      isRtl ? 'left-0' : 'right-0',
    )}
  />
}
